export default __webpack_public_path__ + "b0df460d133da2fc8e5b5a429c6fe40e.png";